import gql from 'graphql-tag';

const WDT_STUDENT_PROGRESS_QUERY = gql`
  query wdtStudentProgressReport(
    $where: WdtStudentProgressReportWhereInput!
    $dateRange: DateRangeInput
  ) {
    wdtStudentProgressReport(where: $where, dateRange: $dateRange) {
      studentId
      characterOrder
      characterGroups {
        id
        name
      }
      characterProgress {
        character {
          id
          characterGroupIds
          character
        }
        level
      }
    }
  }
`;

export default WDT_STUDENT_PROGRESS_QUERY;
